// Filename:    SignIn.js
// Description: This page is the sign in for volunteers and admins.

import React, { useEffect } from "react";

import { Link } from "react-router-dom";



const SignIn = () => {
  useEffect(() => {
    // Code to run only on first page load
    window.scrollTo(0, 0); // scroll to top of page
  }, []);

  const [userName, SetUsername] = React.useState("");
  const [password, SetPassword] = React.useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    // Construct the API endpoint
    //const url = process.env.REACT_APP_API_URL + '/api/foodPantry/signin';
    const url = process.env.REACT_APP_BACKURL + "/api/foodPantry/user"; //uncomment for local testing
    try {
      // Sending the username and password to the server
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userName, password }),
        credentials: "include", // Send cookies
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Login successful:", data);
        window.location.href = "/dashboard"; // Redirect to dashboard
      } else {
        console.log("Login failed:", response.status, response.statusText);
        throw new Error(response.message || "Login failed");
      }
      /* handled above
      if (!response.ok) {
        console.log("Login failed:", response.status, response.statusText);
        throw new Error(response.message || "Login failed");
      }
      

      // Assuming the server responds with JSON data
      const data = await response.json();

      console.log("Login successful:", data);
      console.log("Login successful:", data);

      window.location.href = "/dashboard"; // Example of redirection
      */
    } catch (error) {
      console.error("Error during login:", error.message);
      alert("Login failed: " + error.message);
    }
  };

  const [counter, setCounter] = React.useState(0);
  const [burchCoinActive, setBurchCoinActive] = React.useState(
    localStorage.getItem("BurchCoin") === JSON.stringify(true)
  );

  const activateEasterEgg = () => {
    //increment counter
    setCounter(counter + 1);
    if (counter === 4) {
      //change local storage at BurchCoin to be 1
      //alert("Easter Egg Activated! You found the Burch Coin!");
      localStorage.setItem("BurchCoin", JSON.stringify(true));
      setBurchCoinActive(true);
    }
  }

  const clearEasterEggs = () => {
    setCounter(0);
    localStorage.setItem("BurchCoin", JSON.stringify(false));
    setBurchCoinActive(false);
  };

  const usernameRef = React.useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (usernameRef.current) {
      usernameRef.current.focus();
    }
  }, []);

  return (
    <React.Fragment>
      <div
        style={{
          minHeight: "100vh",
          backgroundImage: burchCoinActive
            ? "url('./images/PizzaBackground.png')"
            : "none",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center"
        }}
      >
        <div className="col-12 d-flex justify-content-center align-items-center min-vh-100">
          <div className="card col-12 col-sm-12 col-md-8 col-lg-6">
            <div className="card-body">
              <div className="col-12 d-flex justify-content-center align-items-center">
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <img
                    src={burchCoinActive
                      ? './images/Burchcoin.png'
                      : './images/BridgingHopeNoWord.svg'
                    }
                    className="img-fluid col-6"
                    alt="logo"
                  />
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                    <button className="circle-btn-orange" onClick={() => { clearEasterEggs() }}></button>
                    <img
                      src="images/BridgingHopeGaramon.png"
                      className="img-fluid col-6"
                      alt="logo"
                    />
                    <button className="circle-btn-orange" onClick={() => { activateEasterEgg() }}></button>
                  </div>

                </div>
              </div>
              <form className="mt-5" onSubmit={handleLogin}>
                <div className="row g-2">
                  <div className="col-12 col-lg-6">
                    <div className="form-floating">
                      <input
                        id="txtUsername"
                        type="text"
                        className="form-control"
                        placeholder="johndoe"
                        aria-label="Enter your username or email here"
                        value={userName}
                        onChange={(e) => SetUsername(e.target.value)}
                        ref={usernameRef}
                      />
                      <label htmlFor="txtUsername" className="form-label">
                        Username or Email
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="form-floating">
                      <input
                        id="txtPassword"
                        type="password"
                        className="form-control"
                        placeholder="123456789"
                        aria-label="Enter your password here"
                        value={password}
                        onChange={(e) => SetPassword(e.target.value)}
                      />
                      <label htmlFor="txtPassword" className="form-label">
                        Password
                      </label>
                    </div>
                  </div>
                </div>

                <button
                  id="btnSignIn"
                  type="submit"
                  className="btn btn-primary col-12 mt-2"
                >
                  Sign In
                </button>
              </form>

              <div className="col-12 d-flex justify-content-center align-items-center mt-2">
                <div className="col-12 row g-2">
                  <Link
                    to="/forgotpassword"
                    href=""
                    className="text-center text-lg-start col-12 col-lg-3"
                  >
                    Forgot Password
                  </Link>
                  <Link to="/register" className="text-lg-center col-12 col-lg-6">
                    Don't have a account? Click here to make one.
                  </Link>
                  <Link
                    to="/"
                    href=""
                    className="text-center text-lg-end col-12 col-lg-3"
                  >
                    Go back to home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="footer">
          <div className="footer-body d-flex justify-content-between mx-4 pb-3">
            <ul className="list-inline mb-0 p-0">
              <li className="list-inline-item">
                <a href="./dashboard/extra/privacy-policy.html">Privacy Policy</a>
              </li>
              <li className="list-inline-item">
                <a href="./dashboard/extra/terms-of-service.html">Terms of Use</a>
              </li>
            </ul>
            <div className="right-panel">
              ©<script>document.write(new Date().getFullYear())</script> Bridging
              Hope. All Rights Reserved.
            </div>
          </div>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default SignIn;
